export default __webpack_public_path__ + "static/media/delivery-app-logo.b8959fed.svg";